// extracted by mini-css-extract-plugin
export default {"container":"Container_container__VVOCq","cards":"Container_cards__RMn3H","link":"Container_link__xuuCW"};